import { currentLocale, type Locale } from './locale'
import { en, it, type MessageKey } from './messages'

/** Una voce del catalogo, nella lingua scelta. `{nome}` si sostituisce. */
export function t(
  locale: Locale,
  key: MessageKey,
  vars?: Record<string, string | number>,
): string {
  let text: string = locale === 'en' ? en[key] : it[key]
  if (vars !== undefined) {
    for (const [name, value] of Object.entries(vars)) {
      text = text.replaceAll(`{${name}}`, String(value))
    }
  }
  return text
}

/** Come `t`, sulla lingua della scheda. Per moduli senza React. */
export function tx(key: MessageKey, vars?: Record<string, string | number>): string {
  return t(currentLocale(), key, vars)
}
